import { render, staticRenderFns } from "./ADomainStatusModal.vue?vue&type=template&id=78a7d3e3&"
import script from "./ADomainStatusModal.vue?vue&type=script&lang=js&"
export * from "./ADomainStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports